import { Button, Dropdown, IconButton } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { ChevronRightIcon, OptionHorizontalIcon, RefreshIcon } from '@zep-us/zus-icons';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';

/** 채팅 패널 상단 — 옵션 드롭다운(대화 재시작) + 대화 접기 버튼. */
export const AiBuilderChatPanelHeader = ({
  onClosePanel,
  onRestartConversation,
  restartDisabled = false
}: {
  onClosePanel: () => void;
  onRestartConversation: () => void;
  /** 대화 재시작을 막는다 — AI 생성기가 같은 세션을 쓰는 동안. */
  restartDisabled?: boolean;
}) => {
  const copy = useAiBuilderChatCopy();
  return <header className="flex flex-none items-center justify-end gap-2xs px-md pb-xs pt-md" data-sentry-component="AiBuilderChatPanelHeader" data-sentry-source-file="AiBuilderChatPanelHeader.tsx">
      <Dropdown.Root modal={false} data-sentry-element="unknown" data-sentry-source-file="AiBuilderChatPanelHeader.tsx">
        <Dropdown.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="AiBuilderChatPanelHeader.tsx">
          <IconButton type="button" variant="outlined" intent="neutral" size="md" rounded="full" aria-label={copy.panel.optionsAriaLabel} data-sentry-element="IconButton" data-sentry-source-file="AiBuilderChatPanelHeader.tsx">
            <OptionHorizontalIcon size="sm" fill={ICON_COLOR.neutral} data-sentry-element="OptionHorizontalIcon" data-sentry-source-file="AiBuilderChatPanelHeader.tsx" />
          </IconButton>
        </Dropdown.Trigger>
        <Dropdown.Content align="end" sideOffset={6} className="z-[70] min-w-[180px]" data-sentry-element="unknown" data-sentry-source-file="AiBuilderChatPanelHeader.tsx">
          <Dropdown.Item className="gap-xs text-body-sm-medium" disabled={restartDisabled} onClick={onRestartConversation} data-sentry-element="unknown" data-sentry-source-file="AiBuilderChatPanelHeader.tsx">
            <RefreshIcon aria-hidden="true" size="sm" fill={ICON_COLOR.neutral} data-sentry-element="RefreshIcon" data-sentry-source-file="AiBuilderChatPanelHeader.tsx" />
            {copy.panel.restart}
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Root>
      <Button type="button" variant="outlined" intent="alternative" size="lg" rounded="full" rightSlot={<ChevronRightIcon size="sm" fill={ICON_COLOR.strong} />} className="w-[120px]" onClick={onClosePanel} data-sentry-element="Button" data-sentry-source-file="AiBuilderChatPanelHeader.tsx">
        {copy.panel.close}
      </Button>
    </header>;
};